import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Canonical empty state — wrapped in `.card` + `.empty`. The icon (if any)
 * sits in a small brand-tinted square; headline + description + optional
 * action button stack vertically.
 */
export function EmptyState({ icon, title, description, action, className = '', ...rest }) {
    return (_jsx("div", { className: `card ${className}`, ...rest, children: _jsxs("div", { className: "empty", children: [icon ? (_jsx("div", { style: {
                        width: 40,
                        height: 40,
                        borderRadius: 'var(--r-md)',
                        background: 'var(--bg-tint)',
                        color: 'var(--brand-300)',
                        display: 'grid',
                        placeItems: 'center',
                        margin: '0 auto 12px',
                    }, children: icon })) : null, _jsx("div", { style: {
                        fontSize: 14,
                        fontWeight: 600,
                        color: 'var(--text-1)',
                        letterSpacing: '-0.01em',
                        marginBottom: 4,
                    }, children: title }), description ? (_jsx("div", { style: {
                        fontSize: 12.5,
                        color: 'var(--text-3)',
                        maxWidth: 420,
                        margin: '0 auto',
                    }, children: description })) : null, action ? (_jsx("div", { style: { marginTop: 16, display: 'flex', justifyContent: 'center' }, children: action })) : null] }) }));
}
//# sourceMappingURL=EmptyState.js.map